import { MANAGE_SUPPLIERS_LAPTOP_MIN_WIDTH_PX } from 'src/constants/manageSuppliers';

export const SUPPLIER_SIDE_PANEL_DESKTOP_WIDTH_PX = 900;
const SUPPLIER_SIDE_PANEL_TABLET_MIN_WIDTH_PX = 768;

/**
 * Width for the supplier side panels. Below laptop width the panel matches the viewport, so a
 * phone in "desktop site" mode (iframe ~800-1000px wide) can't push the header's X off screen.
 */
export const getSupplierSidePanelWidth = (viewportWidth: number): string => {
  if (viewportWidth <= 0 || viewportWidth >= MANAGE_SUPPLIERS_LAPTOP_MIN_WIDTH_PX) {
    return `${SUPPLIER_SIDE_PANEL_DESKTOP_WIDTH_PX}px`;
  }

  if (viewportWidth >= SUPPLIER_SIDE_PANEL_TABLET_MIN_WIDTH_PX) {
    return `${viewportWidth}px`;
  }

  return '100%';
};
